import {Injectable} from '@angular/core';
import {BackendApiService} from '../../services/backend-api.service';
import {LocalStorageService} from 'angular-web-storage';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {UserNotificationService} from '../../services/usernotification.service';
import {ToolsService} from '../../services/tools.service';

export interface BadgeItem {
   type: string;
   value: string;
}

export interface ChildrenItems {
   state: string;
   target?: boolean;
   name: string;
   type?: string;
   icon?: string;
   children?: ChildrenItems[];
}

export interface MainMenuItems {
   state: string;
   short_label?: string;
   main_state?: string;
   target?: boolean;
   name: string;
   type: string;
   icon: string;
   badge?: BadgeItem[];
   children?: ChildrenItems[];
}

export interface Menu {
   label: string;
   main: MainMenuItems[];
}

@Injectable()
export class MenuItems {
   public lsMenuUsuario: any[];
   public sUsuario: any;
   
   constructor(
     private crud: BackendApiService,
     private storage: LocalStorageService,
     private router: Router,
     private userNotification: UserNotificationService,
     public tools: ToolsService
   ) {
   }
   
   public async getMenu(): Promise<Menu[]> {
      this.sUsuario = this.storage.get('usuario');
      
      if (!this.sUsuario) {
         // this.userNotification.modalInfo(
         //   'warning',
         //   'Sesión caducada',
         //   'Por seguridad, vuelve a iniciar sesión'
         // );
         
         await this.router.navigateByUrl('seguridad/login');
         return;
      }
      
      this.lsMenuUsuario = <any[]>await this.crud.getAsync(
        'seguridad/catalogos/menu/byapplicationuser/SIB/' + this.sUsuario.name.toUpperCase()
      ).then((data: any) => {
         const lsData: any[] = data.status === 'OK' ? data.data : [];
         
         if (lsData.length) {
            this.storage.set('menu', lsData);
            
            return lsData.map(oItem => ({
               id: oItem.IDOBJECT,
               idParent: oItem.IDPARENT,
               state: oItem.STATE,
               name: oItem.LABEL,
               icon: oItem.ICON,
               type: oItem.TYPE,
               url: oItem.URL,
               typeObject: oItem.TYPEOBJECT,
               active: oItem.ACTIVE,
               user: oItem.USERNAME,
               target: false
            }));
         } else {
            console.log('Respuesta Menú opciones: ', data);
            this.storage.set('menu', []);
            let title = data.message || (this.sUsuario?.name?.toUpperCase() + ' no tiene opciones de menú asignadas')
     
              this.userNotification.modalInfo(
              'warning',
              title,
              'Consulte con el administrador del sistema',
            );
            
            return [];
         }
      });
   
      if (this.lsMenuUsuario.length) {
         this.lsMenuUsuario = [...this.lsMenuUsuario]
           .filter((oItem: any) => oItem.idParent === null)
           .map((oItem: any) => {
              oItem.target = (oItem.type === 'external');
              oItem.children = ((oItem.typeObject !== 'OPTION') ? this.getSubmenu(oItem.id) : undefined);
              return oItem;
           });
         
         // let lsData = this.loadTree(this.lsMenuUsuario);
         // this.storage.set('menuDx', lsData);
      }
   
      return [{
         label: 'Bagó - Sistema Integrado',
         main: this.lsMenuUsuario
      }];
   }
   
   public search(terms: Observable<string>, lsData: Menu[]): Observable<Menu[]> {
      if (lsData) {
         return undefined;
      }
      
      return terms.pipe(
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(term => this.filterMenu(term, lsData))
      );
   }
   
   private filterMenu(search: string, lsData: Menu[]): Promise<Menu[]> {
      if (!lsData) {
         return undefined;
      }
      
      return new Promise(async resolve => {
         let lsFilter: any;
         
         if (!search) {
            resolve(lsData);
         }
         
         search = search.toLowerCase();
         
         lsFilter = this.filterData(lsData[0].main, function (subject) {
            return subject.name.toLowerCase().includes(search);
         });
         
         resolve(lsFilter ?
           [
              {
                 label: 'Bagó - Sistema Integrado',
                 main: [...lsFilter]
              }
           ]
           : lsData.slice(0));
      });
   }
   
   private filterData(data, predicate) {
      return !!!data
        ? null
        : data.reduce((list, entry) => {
             let clone = null;
             
             if (predicate(entry)) {
                clone = Object.assign({}, entry);
             }
             
             if (entry.children != null) {
                let sub = this.filterData(entry.children, predicate);
                
                if (sub.length > 0) {
                   clone = Object.assign({}, entry, {children: sub});
                }
             }
             
             clone && list.push(clone);
             
             return list;
          }, []
        );
   }
   
   private getSubmenu(idParent: number): ChildrenItems[] {
      let lsResult = this.lsMenuUsuario.filter(oItem => oItem.idParent === idParent);
      
      for (let oItem of lsResult) {
         oItem.target = (oItem.type === 'external');
         oItem.children = ((oItem.typeObject !== 'OPTION') ? this.getSubmenu(oItem.id) : undefined);
      }
      
      return lsResult;
   }
   
   // private loadTree(lsData: any[]): any[] {
   //    let lsResult: any[] = new Array<[]>();
   //
   //    for (let oItem of lsData) {
   //       lsResult.push({
   //          id: oItem.id.toString(),
   //          text: oItem.name,
   //          image: oItem.icon,
   //          icon: oItem.icon,
   //          items: oItem.children ? this.loadTreeChild(oItem.children, oItem.id.toString()) : undefined
   //       });
   //    }
   //
   //    return lsResult;
   // }
   //
   // private loadTreeChild(lsData: any[], sPath: string): any[] {
   //    let lsResult: any[] = new Array<[]>();
   //
   //    for (let oItem of lsData) {
   //       lsResult.push({
   //          id: sPath + '_' + oItem.id.toString(),
   //          text: oItem.name,
   //          image: oItem.icon,
   //          icon: oItem.icon,
   //          items: oItem.children ? this.loadTreeChild(oItem.children, sPath + '_' + oItem.id.toString()) : undefined
   //       });
   //    }
   //
   //    return lsResult;
   // }
}
